import "./RestaurantSelector.css";
import { Select } from "../../../ui";
import { restaurantHasIssues } from "../../utils/ludDocuments.helpers";
export default function RestaurantSelector({
  restaurants,
  value,
  onChange,
  lang,
}) {
  return (
    <div className="lud-restaurant-selector">
      <Select
        label={lang === "ar" ? "المطعم" : "Restaurant"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        options={restaurants.map((r) => ({
          value: r.id,
          label: `${r.name}${restaurantHasIssues(r) ? " • " + (lang === "ar" ? "يحتاج متابعة" : "Needs follow-up") : ""}`,
        }))}
      />
    </div>
  );
}
